__webpack_require__.p = "https://assets-dev.nextorder.co/build-assets/dev-build-2024-08-12-1723452225-beta-dev/";